export const boardViewViewLoaders = {
  loadCalendarControllerView: () =>
    import(/* webpackChunkName: "calendar-controller-view" */ 'app/scripts/views/calendar/calendar-controller-view.coffee').then(
      (m) => m.default,
    ),

  loadMapView: () =>
    import(/* webpackChunkName: "map-view" */ 'app/scripts/views/map/map-view.coffee').then(
      (m) => m.default,
    ),
};
